import { useState } from "react";
import { useNavigate } from "react-router-dom";
import HeroCarousel from "./components/HeroCarousel";
import CategoryShortcuts from "./components/CategoryShortcuts";
import LatestUpdates from "./components/LatestUpdates";
import PopularSidebar from "./components/PopularSidebar";
import SiteIntro from "./components/SiteIntro";
import { getFeaturedMovies, getLatestMovies, getPopularMovies } from "@/utils/movies";

export default function Home() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");
  const featured = getFeaturedMovies();
  const latest = getLatestMovies(20);
  const popular = getPopularMovies(10);

  const submitSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/search?q=${encodeURIComponent(q)}` : "/search");
  };

  return (
    <div className="w-full">
      <HeroCarousel items={featured} />

      <section className="bg-background-100">
        <div className="mx-auto w-full max-w-[1400px] px-4 py-8 md:px-8 md:py-10">
          <div className="mx-auto max-w-3xl text-center">
            <h1 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              日韩伦理片
            </h1>
            <p className="mt-2 text-sm text-foreground-600 md:text-base">
              搜索片名、演员或剧情关键词，快速找到你想了解的作品
            </p>
          </div>
          <form
            onSubmit={submitSearch}
            className="mx-auto mt-6 flex w-full max-w-2xl flex-col gap-3 sm:flex-row"
          >
            <div className="flex flex-1 items-center rounded-md border border-background-300 bg-background-50 px-4">
              <i className="ri-search-line text-lg text-foreground-400" />
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="输入影片名称、地区或剧情关键词"
                className="h-12 w-full bg-transparent px-3 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
              />
            </div>
            <button
              type="submit"
              className="inline-flex h-12 items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-8 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-search-2-line" />
              立即搜索
            </button>
          </form>
        </div>
      </section>

      <CategoryShortcuts />

      <section className="mx-auto w-full max-w-[1400px] px-4 pb-4 md:px-8">
        <div className="flex flex-col gap-8 lg:flex-row lg:gap-6">
          <LatestUpdates movies={latest} />
          <PopularSidebar movies={popular} />
        </div>
      </section>

      <SiteIntro />
    </div>
  );
}